// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pagination-button {
  position: relative;
  margin-bottom: 10px; 
  margin-left: 10rem; 
}

.pagination-button span.number.active{
  color: #ffff;
  font-size: 30px;
  line-height: 42px;
  font-weight: 600;
  font-family:Poppins;
  /* transition:  0.3s ease; */
  
}
.pagination-button span.number{
  cursor: pointer;
  color: #bcbcbc;
  font-family:Poppins;
  font-size: 20px;
  line-height: 30px;
  /* letter-spacing: 1px; */
  font-weight: 600;
  
}
.pagination-button span.tab-line {
  position: absolute; 
  top: 16px;
  width: 240px;
  margin-left: 20px;
  border: 2px solid #ffff;
  background-color: #ffff;
}

@media (min-width:768px) and (max-width: 992px) {
  .pagination-button span.tab-line{
    width: 170px;
  }
  .pagination-button{
    margin-left: 2rem;
    margin-bottom: 12px;
    
  }
  .pagination-button span.number {
    font-size: 25px;
  }
  .pagination-button span.number.active {
    font-size: 35px;
  }

}

@media (max-width: 576px) {

  .sm-pagination{
    display: flex;
    justify-content: center;
    position: absolute;
    top: 85%;
    width: 86%;
    /* transform: translate(-50%, -50%); */
  }
  .sm-pagination-buttons .pagination-button{
    margin: 0;
    padding: 5px;
    width: fit-content;
  }
  .sm-pagination-buttons .pagination-button span.tab-line{
    width: 0;
    height: 25px;
    top: -30px;
    margin-left: -18px;
  }
  .sm-pagination-buttons .pagination-button span.number{
    font-family:Poppins;
    font-size: 25px;
    line-height: 36px;   
  }
  .sm-pagination-buttons .pagination-button span.number.active{
    font-size: 35px;
    line-height: 36px;
   
  }



  .pagination-btns{
    position: fixed;
    top: 38% !important;
  }
  
  .pagination-button {
    position:relative;
    margin-left: 12rem;
    margin-bottom: 10px;
  }
  .pagination-button span.number{
    font-family:Poppins;
    font-size: 20px;
    line-height: 30px;   
  }
  .pagination-button span.number.active{
    font-size: 30px;
    line-height: 30px;
   
  }
  .pagination-button span.tab-line {
    top: 12px;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/common-componets/PaginationButton.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;;AAE9B;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;;AAElB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,mBAAmB;;EAErB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,SAAS;IACT,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;;EAEnB;;;;EAIA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;;EAEnB;EACA;IACE,SAAS;EACX;;AAEF","sourcesContent":["\r\n.pagination-button {\r\n  position: relative;\r\n  margin-bottom: 10px; \r\n  margin-left: 10rem; \r\n}\r\n\r\n.pagination-button span.number.active{\r\n  color: #ffff;\r\n  font-size: 30px;\r\n  line-height: 42px;\r\n  font-weight: 600;\r\n  font-family:Poppins;\r\n  /* transition:  0.3s ease; */\r\n  \r\n}\r\n.pagination-button span.number{\r\n  cursor: pointer;\r\n  color: #bcbcbc;\r\n  font-family:Poppins;\r\n  font-size: 20px;\r\n  line-height: 30px;\r\n  /* letter-spacing: 1px; */\r\n  font-weight: 600;\r\n  \r\n}\r\n.pagination-button span.tab-line {\r\n  position: absolute; \r\n  top: 16px;\r\n  width: 240px;\r\n  margin-left: 20px;\r\n  border: 2px solid #ffff;\r\n  background-color: #ffff;\r\n}\r\n\r\n@media (min-width:768px) and (max-width: 992px) {\r\n  .pagination-button span.tab-line{\r\n    width: 170px;\r\n  }\r\n  .pagination-button{\r\n    margin-left: 2rem;\r\n    margin-bottom: 12px;\r\n    \r\n  }\r\n  .pagination-button span.number {\r\n    font-size: 25px;\r\n  }\r\n  .pagination-button span.number.active {\r\n    font-size: 35px;\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 576px) {\r\n\r\n  .sm-pagination{\r\n    display: flex;\r\n    justify-content: center;\r\n    position: absolute;\r\n    top: 85%;\r\n    width: 86%;\r\n    /* transform: translate(-50%, -50%); */\r\n  }\r\n  .sm-pagination-buttons .pagination-button{\r\n    margin: 0;\r\n    padding: 5px;\r\n    width: fit-content;\r\n  }\r\n  .sm-pagination-buttons .pagination-button span.tab-line{\r\n    width: 0;\r\n    height: 25px;\r\n    top: -30px;\r\n    margin-left: -18px;\r\n  }\r\n  .sm-pagination-buttons .pagination-button span.number{\r\n    font-family:Poppins;\r\n    font-size: 25px;\r\n    line-height: 36px;   \r\n  }\r\n  .sm-pagination-buttons .pagination-button span.number.active{\r\n    font-size: 35px;\r\n    line-height: 36px;\r\n   \r\n  }\r\n\r\n\r\n\r\n  .pagination-btns{\r\n    position: fixed;\r\n    top: 38% !important;\r\n  }\r\n  \r\n  .pagination-button {\r\n    position:relative;\r\n    margin-left: 12rem;\r\n    margin-bottom: 10px;\r\n  }\r\n  .pagination-button span.number{\r\n    font-family:Poppins;\r\n    font-size: 20px;\r\n    line-height: 30px;   \r\n  }\r\n  .pagination-button span.number.active{\r\n    font-size: 30px;\r\n    line-height: 30px;\r\n   \r\n  }\r\n  .pagination-button span.tab-line {\r\n    top: 12px;\r\n  }\r\n  \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
